import { useQuery } from '@tanstack/vue-query';

import { getMe } from '../api';

/** The authenticated user's own record. */
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => (await getMe()).data,
  });
}
